const usCollection = {
  collection: {}
}

module.exports = usCollection
